<template>
<div :class="{'en': en}">
  <SectionWrapper :category="$t('_cate_studnet')" :title="$t('_info_enrollment')" section-id="section_1" >
    <SectionLi :sub-title="en?'Total Enrollment':'在學人數(含研究所)'">
      <p class="item-content content-type-simple">
        <span class="item-content-highlight">{{ numberWithCommas(data.section_one_text.enrollment) }}</span>{{ en?'ppl':'人' }}
      </p>
    </SectionLi>
    <SectionLi :sub-title="en?'Male to Female Ratio':'男女比例(含研究所)'">
      <p class="item-content content-type-simple">
       {{ en?'about':'約' }}<span class="item-content-highlight">{{ data.section_one_text.genderRatio }}</span>
      </p>
    </SectionLi> 

    <template v-slot:chart>
       <ChartP5 src="../chartJS/chart_1.js" :data="data.section_one_chart" :en="en" id="1"/>
    </template>
  </SectionWrapper>

  <SectionWrapper :category="$t('_cate_studnet')" :title="$t('_info_college')" section-id="section_2">
    <SectionLi :sub-title="en?'College & Program':'學士班總數'" :two-row="true">
      <p v-if="!en" class="item-content content-type-simple">
        <span class="item-content-highlight">{{ data.section_two_text.college }}</span>院 
        <span class="item-content-highlight">{{ data.section_two_text.bachler.class }}</span>系 
        <span class="item-content-highlight">{{ data.section_two_text.bachler.program }}</span>學程
      </p>
      <p v-if="en" class="item-content content-type-simple">
        <span class="item-content-highlight">{{ data.section_two_text.college }}</span>College
        <span class="item-content-highlight">{{ data.section_two_text.bachler.class + data.section_two_text.bachler.program }}</span>Program 
      </p>
    </SectionLi>
    <SectionLi :sub-title="en?'Masters':'碩士班總數'">
      <p v-if="!en" class="item-content content-type-simple">
          <span class="item-content-highlight">{{ data.section_two_text.master.class }}</span>系/所
          <span class="item-content-highlight">{{ data.section_two_text.master.program }}</span>學程
      </p>
      <p v-if="en" class="item-content content-type-simple">
          <span class="item-content-highlight">{{ data.section_two_text.master.class + data.section_two_text.master.program  }}</span>Program 
      </p>
    </SectionLi>
    <SectionLi :sub-title="en?'Masters In Work':'碩士在職專班總數'">
      <p v-if="!en" class="item-content content-type-simple">
          <span class="item-content-highlight">{{ data.section_two_text.masterInWork.class }}</span>系/所
          <span class="item-content-highlight">{{ data.section_two_text.masterInWork.program }}</span>學程
      </p>
      <p v-if="en" class="item-content content-type-simple">
          <span class="item-content-highlight">{{ data.section_two_text.masterInWork.class + data.section_two_text.masterInWork.program  }}</span>Program 
      </p>
    </SectionLi>
    <SectionLi :sub-title="en?'Doctorate':'博士班總數'">
      <p v-if="!en" class="item-content content-type-simple">
          <span class="item-content-highlight">{{ data.section_two_text.doctor.class }}</span>系/所 
          <span class="item-content-highlight">{{ data.section_two_text.doctor.program }}</span>學程
      </p>
      <p v-if="en" class="item-content content-type-simple">
          <span class="item-content-highlight">{{ data.section_two_text.doctor.class + data.section_two_text.doctor.program }}</span>Program 
      </p>
    </SectionLi>

    <template v-slot:chart>
       <ChartP5 src="./chartJS/chart_2.js" :data="data" :en="en" id="2"/>
    </template>
  </SectionWrapper>

  <SectionWrapper :category="$t('_cate_studnet')" :title="$t('_info_InternationalDiversity')" section-id="section_3">
    <SectionLi :sub-title="en?'Overseas Student':'境外學生'" v-if="data.dataYear > 107" >
      <p class="item-content content-type-list">
        <span class="item-content-highlight">{{  numberWithCommas(chart3Total(data.section_three_text)) }}</span>{{ en?'ppl':'人' }}
      </p>
      <ul class="item-content-list">               
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'International':'國際學生' }}</p>
              <p class="item-list-content-content">
                <span class="item-list-content-highlight">{{ data.section_three_text.international }}</span>{{ en?'':'人' }}
              </p>
          </li>
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Overseas Chinese':'僑生' }}</p>
              <p class="item-list-content-content">
                <span class="item-list-content-highlight">{{ data.section_three_text.overseaChinese }}</span>{{ en?'':'人' }}
              </p>                
          </li>
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Hong Kong & Macau':'港澳生' }}</p>
              <p class="item-list-content-content">
                <span class="item-list-content-highlight">{{ data.section_three_text.hkmacau }}</span>{{ en?'':'人' }}
              </p>            
          </li> 
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Mainland China':'陸生' }}</p>
              <p class="item-list-content-content">
                <span class="item-list-content-highlight">{{ data.section_three_text.mainland }}</span>{{ en?'':'人' }}
              </p>            
          </li> 
      </ul>     
    </SectionLi>

    <SectionLi v-if="data.section_three_text.outboundEx!= 0" :sub-title="en?'Outbound exchange':'薦外交換學生'">
        <p class="item-content content-type-simple">
          <span class="item-content-highlight">{{  numberWithCommas(data.section_three_text.outboundEx) }}</span>{{ en?'':'人' }}
        </p>
    </SectionLi>

    <template v-slot:chart>
       <ChartP5 src="./chartJS/chart_3.js" :data="data.section_three_chart" :en="en" id="3"/>
    </template>
  </SectionWrapper>

  <SectionWrapper :category="$t('_cate_studnet')" :title="$t('_info_graduation')" section-id="section_4">
    <SectionLi v-if="data.dataYear < 107" :sub-title="'無資料'">

    </SectionLi>
    <SectionLi v-else :sub-title="en?data.section_four_chart.dataInfoEn:data.section_four_chart.dataInfo">
      <p class="item-content content-type-list">
        <span class="item-content-highlight">{{ numberWithCommas(data.section_four_text.total) }}</span>{{ en?'ppl':'人' }}
      </p>
      <ul class="item-content-list">               
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Undergraduate Degrees':'學士班' }}</p>
              <p class="item-list-content-content">
                <span class="item-list-content-highlight">{{ numberWithCommas(data.section_four_text.bachler) }}</span>{{ en?'':'人' }}
              </p>
          </li>
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Master Degrees':'碩士班' }}</p>
              <p class="item-list-content-content">
                <span class="item-list-content-highlight">{{ numberWithCommas(data.section_four_text.master) }}</span>{{ en?'':'人' }}
              </p>                
          </li>
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Master In Work Degrees':'在職專班' }}</p>
              <p class="item-list-content-content">
                <span class="item-list-content-highlight">{{ numberWithCommas(data.section_four_text.masterInWork) }}</span>{{ en?'':'人' }}
              </p>            
          </li> 
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Doctoral Degrees':'博士班' }}</p>
              <p class="item-list-content-content">
                <span class="item-list-content-highlight">{{ numberWithCommas(data.section_four_text.doctor) }}</span>{{ en?'':'人' }}
              </p>            
          </li> 
      </ul>     
    </SectionLi>

    <template v-slot:chart v-if="data.dataYear > 106">
       <ChartP5 src="./chartJS/chart_4.js" :data="data.section_four_chart" :en="en" id="4"/>
    </template>
  </SectionWrapper>

  <template v-if="data.dataYear <= lastestyear">
  <SectionWrapper :category="en?'STUDENT':'學生'" :title="$t('_info_majorMinor')" section-id="section_5">
    <SectionLi :sub-title="en?'Double major':'取得雙主修資格畢業生'">
      <p class="item-content content-type-simple">
        <span class="item-content-highlight">{{ data.section_five_text.doublemajor }}</span>{{ en?"ppl":"位" }}
      </p>
    </SectionLi>
    <SectionLi :sub-title="en?'Minor major':'取得輔系資格畢業生'">
      <p class="item-content content-type-simple">
        <span class="item-content-highlight">{{ data.section_five_text.minor }}</span>{{ en?"ppl":"位" }}
      </p>
    </SectionLi>

    <template v-slot:chart>
      <div class="chart" style="align-self: flex-center;"></div>
       <ChartP5 src="./chartJS/chart_5.js" :data="data" :en="en" id="5"/> 
    </template>
  </SectionWrapper>
  </template>
  
  <SectionWrapper :category="$t('_cate_teacher')" :title="en?'Faculty':'教師人數'" section-id="section_6">        
    <SectionLi :sub-title="en?'Total Faculty':'全校教師總人數'">
      <p class="item-content content-type-list">
        <span class="item-content-highlight">{{ numberWithCommas(data.section_six_text.fulltime+data.section_six_text.parttime) }}</span>{{ en?'ppl':'位' }}
      </p>

      <ul class="item-content-list">               
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Full-time Faculty':'專任教師總人數' }}</p>
              <p class="item-list-content-content">
                <span class="item-list-content-highlight">{{ numberWithCommas(data.section_six_text.fulltime) }}</span>{{ en?'ppl':'位' }}
              </p>
          </li>
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Part-time Faculty':'兼任教師總人數' }}</p>
              <p class="item-list-content-content">
                <span class="item-list-content-highlight">{{ numberWithCommas(data.section_six_text.parttime) }}</span>{{ en?'ppl':'位' }}
              </p>                
          </li>
      </ul>  
    </SectionLi>

    <SectionLi :sub-title="en?'Day Division Ratio':'日間學制生師比例'" :two-row="true">
       <p class="item-content content-type-simple">
        <span class="item-content-highlight">{{ data.section_seven_text.daySchool }}</span>
          <template v-if="!en">生/師</template>
          <template v-if="en">student/faculty</template>        
        </p>
    </SectionLi>
   
    <template v-slot:chart>
       <ChartP5 src="./chartJS/chart_6.js" :data="data" :en="en" id="6"/>
    </template>
  </SectionWrapper>

  <SectionWrapper  :category="$t('_cate_teacher')" :title="en?'Foreign teacher':'外籍教師'" section-id="section_8">
    <SectionLi :sub-title="en?'Foreign Full-time Teacher':'外籍專任教師數'">
      <p class="item-content content-type-simple">
        <span class="item-content-highlight">{{ data.section_eight_text.all }}</span>{{ en?"":"位" }}
      </p>
    </SectionLi>
    <SectionLi :sub-title="en?'Foreign Full-time Teacher Ratio':'外師比例'">
      <p class="item-content content-type-simple">
        <span class="item-content-highlight">{{ data.section_eight_text.portion }}%</span>
      </p>
    </SectionLi>

    <template v-slot:chart>
      <div class="chart" style="align-self: flex-center;"></div>
       <ChartP5 src="./chartJS/chart_8.js" :data="data" :en="en" id="8"/> 
    </template>
  </SectionWrapper>

  <template v-if="data.dataYear <= lastestyear">

  <SectionWrapper :category="$t('_cate_research')" :title="en?'Findings':'計畫經費'" section-id="section_9">
    <SectionLi :sub-title="en?'Reasearch Fundings':'各類計畫經費'">
       <p class="item-content content-type-simple">{{ en?'NT$':'' }}<span class="item-content-highlight">{{ numberWithCommas(data.section_nine_text.total) }}</span>{{ en?'':'元' }}</p>
    </SectionLi>
    <SectionLi :sub-title="en?'Industry-University Collaboration':'產學合作計畫經費'">
      <p class="item-content content-type-simple">{{ en?'NT$':'' }}<span class="item-content-highlight">{{ numberWithCommas(data.section_nine_text.coop) }}</span>{{ en?'':'元' }}</p>
    </SectionLi>
        <SectionLi :sub-title="en?'Reasearch':'學術研究計畫經費'">
      <p class="item-content content-type-simple">{{ en?'NT$':'' }}<span class="item-content-highlight">{{ numberWithCommas(data.section_nine_text.research) }}</span>{{ en?'':'元' }}</p>
    </SectionLi>
    <template v-slot:chart>
       <ChartP5 src="./chartJS/chart_9.js" :data="data" :en="en" id="9"/>
    </template>
    
  </SectionWrapper>
  </template>

  <SectionWrapper :category="$t('_cate_other')" :title="en?'Library':'圖書資料'" section-id="section_10">
    <SectionLi :sub-title="en?'Collections':'紙本圖書藏書量'">
       <p class="item-content content-type-simple">
        <template v-if="!en">
          <span class="item-content-highlight">{{ numberWithCommas(parseInt(data.section_ten_text.paper / 10000)) }}</span>萬餘冊
        </template>
        <template v-if="en">
          <span class="item-content-highlight">{{ numberWithCommas(parseInt(data.section_ten_text.paper / 1000)) }}</span>thousand
        </template>
      </p>
    </SectionLi>
    <SectionLi :sub-title="en?'E-Resources':'電子資料可使用量'">
      <p class="item-content content-type-simple">
        <template v-if="!en">
          <span class="item-content-highlight">{{ numberWithCommas(parseInt(data.section_ten_text.digital / 10000)) }}</span>萬餘冊
        </template>
        <template v-if="en">
          <span class="item-content-highlight">{{ numberWithCommas(parseInt(data.section_ten_text.digital / 1000)) }}</span>thousand
        </template>
      </p>
    </SectionLi>
    <SectionLi :sub-title="en?'Service users':'服務人次'">
      <ul class="item-content-list">               
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Borrowers':'借閱人次' }}</p>
              <p class="item-list-content-content"><span class="item-list-content-highlight">{{  numberWithCommas(data.section_ten_text.servePpl) }}</span>{{ en?'times':'次' }}</p>
          </li>
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Borrowed items':'借閱冊次' }}</p>
              <p class="item-list-content-content"><span class="item-list-content-highlight">{{  numberWithCommas(data.section_ten_text.serveBook) }}</span>{{ en?'times':'冊' }}</p>                 
          </li>
          <li class="item-list-content-grid">
              <p class="item-list-content-title">{{ en?'Databases':'線上及光碟資料庫' }}</p>
              <p class="item-list-content-content"><span class="item-list-content-highlight">{{  numberWithCommas(data.section_ten_text.serveDigi)}}</span>{{ en?'times':'次' }}</p>                 
          </li>
      </ul>       
    </SectionLi>

    <template v-slot:chart>
       <ChartP5 src="./chartJS/chart_10.js" :data="data.section_ten_text" :en="en" id="10"/>
    </template>
  </SectionWrapper>

  <SectionWrapper :category="$t('_cate_other')" :title="en?'Campus Information':'校地面積'" section-id="section_11">
    <SectionLi :sub-title="en?'Total Area':'校地總面積'">
      <p class="item-content content-type-simple">
        <span class="item-content-highlight">{{  numberWithCommas(data.section_eleven_text.total) }}</span> {{ en?'m²':'平方公尺'}}
      </p>
    </SectionLi>
    <SectionLi :sub-title="en?'Total Floor Area of School Buildings':'校舍總樓地板面積'">
      <p class="item-content content-type-simple">
        <span class="item-content-highlight">{{  numberWithCommas(data.section_eleven_text.building) }}</span> {{ en?'m²':'平方公尺'}}
      </p>
    </SectionLi>

    <template v-slot:chart>
       <ChartP5 src="./chartJS/chart_11.js" :data="data.section_eleven_text" :en="en" id="11"/>
    </template>
  </SectionWrapper>

  <SectionWrapper :category="$t('_cate_other')" :title="en?'Campus Information':'校園資訊'" section-id="section_12">
    <SectionLi :sub-title="en?'Hiking Trail':'健行步道總長'">
       <p class="item-content content-type-simple">
        <span class="item-content-highlight">{{ data.section_twelve_text.hikingTrail }}</span>{{ en?'km':'公里'}}
       </p>
    </SectionLi>
    <SectionLi :sub-title="en?'It takes':'全部走完約需'">
      <p class="item-content content-type-simple">
        {{ en?'about':''}}<span class="item-content-highlight">{{ data.section_twelve_text.time }}</span>{{ en?'hours to finish all':'小時'}}
      </p>
    </SectionLi>
    <template v-slot:chart>
       <ChartP5 src="./chartJS/chart_12.js" :data="data" :en="en" id="12"/>
    </template>
  </SectionWrapper>

</div>
</template>

<script>
import SectionWrapper from '@/components/IndexSectionWrapper.vue';
import SectionLi from '@/components/IndexSection.vue';
import ChartP5 from '@/components/ChartP5.vue';
// import chartScrolls from '@/assets/js/chartScroll'

export default {
  components: { SectionWrapper, SectionLi, ChartP5 },
  props: ["data", "datayear", "en", "lastestyear"],

  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    chart3Total(data) {
      let total = data.international + data.overseaChinese + data.hkmacau + data.mainland;
      return total;
    },
    
    chart9Total(data, type) {
      let yearFrom = data.start;
      let yearEnd = data.end
      let total = 0;
      for(let year = yearFrom; year <= yearEnd; year ++) {
          let func = "data.y" + year + "."+ type;
          
          total += eval(func);
      }
      return total;
    }
  },

  onUnmounted()  {
    triggers.forEach((trigger) => {
    // 把 ScrollTrigger 綁定的動畫消除
      trigger.kill();
    });
    // 消除綁定 MatchMedia();
    ScrollTrigger.clearMatchMedia();
  }


}
</script>

<style src="@/assets/css/overview.css" scoped></style>
<style src="@/assets/css/overviewEn.css"></style>